import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export var ENVIRONMENT;
(function (ENVIRONMENT) {
    ENVIRONMENT["DEV"] = "DEVELOPMENT";
    ENVIRONMENT["PROD"] = "PRODUCTION";
})(ENVIRONMENT || (ENVIRONMENT = {}));
const EnvironmentContext = createContext({
    flagInDevelopment: () => { },
});
export const useEnvironment = () => useContext(EnvironmentContext);
export const EnvironmentProvider = ({ env, children }) => {
    const flagInDevelopment = (message) => {
        if (env === ENVIRONMENT.DEV) {
            throw new Error(message);
        }
        else {
        }
    };
    return (_jsx(EnvironmentContext.Provider, Object.assign({ value: {
            env,
            flagInDevelopment,
        } }, { children: children })));
};
